import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';


function SwecOrientationDayBtechBatch202529_20250821() {

    const images = [
        "34c0ef33-69ac-4f24-bcef-ed8398a25484.jpg",
        "namaste-telangana-swec.jpeg",
        "eenadu.jpeg",
        "sakshi.jpeg",
    ];
    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">
                                <div className="how-to-apply">
                                    <h2 className='pb-2'>
                                        SWEC conducted it's Orientation day for the B.Tech batch 2025-29 on 21st Aug 2025
                                    </h2>
                                    <div className='pb-2'>
                                        <p>
                                            SWEC successfully conducted an Orientation Day program for B.Tech first-year students on August 21, 2025. The program was formally inaugurated by Ms. Pratyusha Sharma, HR Head, Invesco Pvt. Ltd., in the presence of Dr. K. RadhaKishan Rao, Vice Chairman, SWEC.
                                        </p>

                                    </div>

                                    <div class="spotlight-group">
                                        <div class="row">


                                            {images.map((img, index) => (
                                                <div className="col-md-6 mb-3 mb-lg-4" key={index}>
                                                    <a
                                                        className="spotlight"
                                                        href={`https://admin.swec.ac.in/assetsswec/img/swec-orientation-day-btech-batch-2025-29/${img}`}
                                                    >
                                                        <img
                                                            src={`https://admin.swec.ac.in/assetsswec/img/swec-orientation-day-btech-batch-2025-29/${img}`}
                                                            alt={`Image ${index + 1}`}
                                                            className="img-responsive center-block"
                                                        />
                                                    </a>
                                                </div>
                                            ))}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default SwecOrientationDayBtechBatch202529_20250821
